<template>
  <v-container fluid>
    <v-row>
      <!-- name/title card -->
      <v-col>
        <v-card>
          <v-card-title class="headline font-weight-medium">
            Compliance Settings
            <v-spacer />
          </v-card-title>
          <v-card-subtitle class="title font-weight-regular">{{ getOrg }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>


    <!-- API Settings screenOnCreate, etc -->
     <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-card-title>
            Automation & API Settings
            <v-spacer />
            <v-btn icon @click="onEditAutoApiClick()" color="blue">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>Configure application behavior when API requests are received.</v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col>
                Screen cases immedietly on creation.
              </v-col>
              <v-col>
                <span v-if="!getAccount.accountSettings">

                </span>     
                <span v-else-if="this.getAccount.accountSettings.screenOnCreate">
                  <v-icon color="blue">mdi-check-circle</v-icon> On
                </span>
                <span v-else>
                  <v-icon color="red">mdi-close-circle</v-icon> Off  
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                Create cases when screened.
              </v-col>
              <v-col>
                <span v-if="!getAccount.accountSettings">

                </span>
                <span v-else-if="this.getAccount.accountSettings.createOnScreen">
                  <v-icon color="blue">mdi-check-circle</v-icon> On
                </span>
                <span v-else>
                  <v-icon color="red">mdi-close-circle</v-icon> Off  
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
     </v-row>




    <!-- Datasets  -->
    <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-card-title>
            Data Sets
            <v-spacer />
            <v-btn icon @click="onEditSourcesClick()" color="blue">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>Which sanction sources cases will be screened against.</v-card-subtitle>
          <v-card-text>
            <template
              v-if="getAccount.accountSettings && getAccount.accountSettings.lists && getAccount.accountSettings.lists.length > 0">
              <v-chip class="ma-1" v-for="source in getAccount.accountSettings.lists" :key="source">
                {{ source }}
              </v-chip>
            </template>
            <template v-else><i>No sanction sources set. Defaulting to US Treasury Department.</i></template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <EditComplianceSources :visible="isEditSourcesVisible" :account="this.getAccount"
      v-on:onCancelled="onEditSourcesCancelled" />

    <EditComplianceAutoApi :visible="isEditAutoApiVisible" :account="this.getAccount"
      v-on:onCancelled="onEditAutoApiCancel" />

  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EditComplianceSources from "../../modals/account settings/EditComplianceSources";
import EditComplianceAutoApi from "../../modals/account settings/EditComplianceAutoApi";

export default {
  name: "ComplianceSettings",
  components: {
    EditComplianceSources, EditComplianceAutoApi
  },
  data() {
    return {
      loading: true,
      isEditSourcesVisible: false,
      isEditAutoApiVisible: false
    };
  },
  methods: {
    ...mapActions(["fetchAccount", "setGlobalAlert"]),
    onEditSourcesClick() {
      this.isEditSourcesVisible = true;
    },
    onEditSourcesCancelled() {
      this.isEditSourcesVisible = false;
    },
    onEditAutoApiClick(){
      this.isEditAutoApiVisible = true;
    },
    onEditAutoApiCancel(){
      this.isEditAutoApiVisible = false;
    },
  },
  computed: {
    ...mapGetters(["getAccount", "getOrg"]),
  },
  created() {
    this.fetchAccount()
      .catch(() => {
        this.setGlobalAlert({
          alert: true,
          color: 'red',
          alertTitle: "There's been a problem",
          alertMessage:
            "Unable to retrieve account information. Please try again shortly. "
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>